module.exports = __webpack_public_path__ + "static/media/tipo1.07a39d7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wish-list/Modal/tipo1.png
// module id = 2016
// module chunks = 0